export enum SubmitChartConstants {
  NOT_IMPLEMENTED = 'submitChart/NOT_IMPLEMENTED',
  SET_PRE_SUBMIT_CHART = 'submitChart/SET_PRE_SUBMIT_CHART',
  SUBMIT_CHART = 'submitChart/SUBMIT_CHART',
  SET_POST_SUBMIT_CHART = 'submitChart/SET_POST_SUBMIT_CHART',
  RESET_STATE = 'submitChart/RESET_STATE',
  GET_SUBMIT_CHART_STATE = 'submitChart/GET_SUBMIT_CHART_STATE',
  SET_SUBMIT_CHART_STATE = 'submitChart/SET_SUBMIT_CHART_STATE',
  SET_VALIDATION_MESSAGE = 'submitChart/SET_VALIDATION_MESSAGE',
  UPDATE_SUBMIT_CHART_VALIDATION_STATE = 'submitChart/UPDATE_SUBMIT_CHART_VALIDATION_STATE',
  GET_SUBMIT_CHART_VALIDATION_ARRAY = 'submitChart/GET_SUBMIT_CHART_VALIDATION_ARRAY',
}
